import { useState } from 'react';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import {
  PRIVACY_SETTINGS_KEY,
  PrivacySettingsParams,
  updatePrivacySettings,
} from '@utils/backend-api/settings';

export default function usePrivacySettingsUpdate() {
  const queryClient = useQueryClient();
  const [showSave, setShowSave] = useState(false);

  const { mutate, data, isLoading, isError } = useMutation(
    (params: PrivacySettingsParams) => updatePrivacySettings(params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(PRIVACY_SETTINGS_KEY);
        setShowSave(true);
        setTimeout(() => {
          setShowSave(false);
        }, 3000);
      },
      onError: () => {
        toast.error(
          "We couldn't update your privacy settings. Please try again or contact support@theinformation.com."
        );
      },
    }
  );
  return { mutate, data, isLoading, isError, showSave };
}
